export default {
  taskDescription: '任务描述',
  taskPlaceholder: '请输入任务，例如：巡检A区异常堆放并获取合格照片',
  buttons: {
    start: '开始任务',
    stop: '停止任务',
    creating: '任务创建中...',
    running: '任务执行中...',
    stopFirst: '请先停止任务',
  },
  kg: {
    title: '任务匹配知识图谱子图',
    subtitle: '从用户任务映射到相关实体、动作与协同关系',
    emptyDesc: '请输入任务描述并点击「开始任务」，系统将解析任务并加载对应的知识图谱子图。',
  },
  video: {
    title: '机器狗实时视野',
  },
  progress: {
    title: '任务执行进度',
    subtitle: '持续展示阶段、主体、升级原因及步骤状态',
    emptyDesc: '请输入任务描述并点击「开始任务」，系统将实时展示执行步骤。',
  },
  empty: {
    waitingTitle: '等待任务开始',
  },
  status: {
    online: '在线',
    offline: '离线',
    unknown: '未知',
    unnamedDevice: '未命名设备',
  },
  messages: {
    taskStopped: '任务已停止',
    stopFailed: '停止任务失败，请重试',
    taskNotCreated: '任务尚未创建完成',
    taskCreateFailed: '任务创建失败',
    pipelineError500: 'Pipeline 服务错误（500）',
    dogError500: '机器狗服务错误（500）',
    pipelineUnavailable404: 'Pipeline 服务不可用（404）',
    dogUnavailable404: '机器狗服务不可用（404）',
    dogTaskNoId: '机器狗任务创建失败：未返回 task_id',
    pipelineNoRunId: 'Pipeline 任务创建失败：未返回 run_id',
    connectionInterrupted: '连接中断，请检查网络或后端服务。',
  },
  defaultTaskName: '日常巡检任务',
}
